"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.ButtonComponent = void 0;
var _mui = require("@ori-ui/mui");
const ButtonComponent = exports.ButtonComponent = (0, _mui.styled)('div')(({
  isChatOpened,
  theme
}) => {
  const buttonExpanded = {
    maxWidth: '100%',
    transitionDelay: '0s',
    div: {
      opacity: 1,
      transitionDelay: '0.2s'
    }
  };
  return {
    alignItems: 'center',
    background: theme.palette.default.main,
    borderRadius: '30px',
    bottom: '15px',
    boxShadow: _mui.SHADOW_LEVEL1,
    boxSizing: 'unset',
    color: theme.palette.common.white,
    cursor: 'pointer',
    direction: 'rtl',
    display: 'flex',
    flexDirection: 'row',
    height: '60px',
    maxWidth: '60px',
    overflow: 'hidden',
    position: 'fixed',
    right: '15px',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    textTransform: 'uppercase',
    transition: 'max-width 0.5s ease-in-out 0.2s',
    userSelect: 'none',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
    width: 'auto',
    zIndex: 100,
    [theme.breakpoints.up('md')]: {
      bottom: '30px',
      right: '30px'
    },
    '&:focus, &:hover': buttonExpanded,
    ...(isChatOpened ? buttonExpanded : undefined)
  };
});
const Label = exports.Label = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'block',
  fontSize: '1.4rem',
  fontWeight: theme.typography.fontWeightBold,
  opacity: 0,
  paddingLeft: theme.spacing(4),
  transition: 'opacity 0.3s ease-in-out'
}));
